import styled from 'styled-components';

import { PromotionalEventCompletionState } from '#src/__generated__/globalTypes.ts';
import { ConversionCreditBanner } from '#src/components/conversionCredit/ConversionCreditBanner/index.tsx';
import { ReferralBanner } from '#src/components/referral/ReferralBanner/index.tsx';
import { CompactBanner } from '#src/components/wallet/BankEthAccounting/AddFundsToFiatWallet/promo/CompactBanner/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useConversionCredit } from '#src/hooks/useConversionCredit.ts';
import { useLifecycle } from '#src/hooks/useLifecycle.ts';

const Wrapper = styled.div`
  width: 100%;
  padding: var(--unit) 0;
`;

export const Banners = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  const conversionCredit = useConversionCredit(sport);
  const { lifecycle } = useLifecycle();

  const referralBannerHidden =
    !currentUser ||
    lifecycle?.hideReferralBanner ||
    currentUser.referralRewardsCount > 0;
  const conversionCreditBannerHidden =
    currentUser?.userSettings?.hideBalance || !conversionCredit;

  if (
    currentUser?.completablePromotionalEvent?.promotionalEventCompletion
      ?.aasmState === PromotionalEventCompletionState.PENDING
  ) {
    return (
      <Wrapper>
        <CompactBanner showInprogress showDepositCta={false} />
      </Wrapper>
    );
  }

  if (referralBannerHidden && conversionCreditBannerHidden) {
    return null;
  }

  if (!(currentUser?.userSettings?.hideBalance || !conversionCredit)) {
    return <ConversionCreditBanner />;
  }
  if (sport) {
    return <ReferralBanner sport={sport} />;
  }
  return null;
};
